module.exports = __webpack_public_path__ + "img/most_read.e4d8ae80.svg";